import { FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useQuery } from 'react-query'
import { MaterialReactTable, MRT_ColumnDef, MRT_PaginationState, useMaterialReactTable } from 'material-react-table'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import { EBonusMaxBet } from '@lbs/shared-rp-types'
import { Prp2boxApiBonus } from '../../prp2boxApi'
import { IRpBonus } from '../../prp2boxApi/bonuses'
import mrtLocalization from '../../constants/mrtLocalization'
import { EDrawerView } from '../../stores/DrawerCRUD.store'
import { useStore } from '../../stores'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { formatToMoscowTZ } from '../../utils/date'
import { bonusMaxLabels } from '../RpBonusForm/base'

const columns: MRT_ColumnDef<IRpBonus>[] = [
  {
    accessorKey: 'name',
    header: 'Имя',
  },
  {
    accessorKey: 'min',
    header: 'Минимум',
  },
  {
    accessorKey: 'max',
    header: 'Максимум',
    Cell: ({ cell }) => {
      const value = cell.getValue<EBonusMaxBet>()

      return bonusMaxLabels[value] || value
    },
  },
  {
    accessorKey: 'maxPayout',
    header: 'Максимальная выплата',
    Cell: ({ cell }) => {
      return cell.getValue<number | null>() || 'no limit'
    },
  },
  {
    accessorKey: 'updatedAt',
    header: 'Последнее обновление',
    sortingFn: 'datetime',
    Cell: ({ cell }) => {
      return formatToMoscowTZ(cell.getValue<string>())
    },
  },
]

const RpBonusesTable: FC = observer(() => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  })

  const { drawerCRUDStore } = useStore()

  const { data, isError, isFetching, isLoading } = useQuery(
    [EQueryKeysConstant.RP_BONUSES, pagination.pageIndex, pagination.pageSize],
    async () => {
      return Prp2boxApiBonus.getAll({
        limit: pagination.pageSize,
        offset: pagination.pageIndex * pagination.pageSize,
      })
    },
    {
      refetchOnWindowFocus: false,
      onError: (err) => toast.error(`${err}`),
      enabled: true,
      keepPreviousData: true,
    }
  )

  const table = useMaterialReactTable({
    ...mrtLocalization,
    enableGlobalFilter: false,
    data: data?.rows || [],
    columns,
    rowCount: data?.totalRows || 0,
    state: {
      pagination,
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isFetching,
    },
    manualPagination: true,
    onPaginationChange: setPagination,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        event.preventDefault()
        event.stopPropagation()

        drawerCRUDStore.changeView(EDrawerView.RP_BONUS_EDIT, String(row.original.id))
      },
      sx: {
        cursor: 'pointer',
      },
    }),
    renderTopToolbarCustomActions: () => {
      return (
        <Button
          variant="contained"
          onClick={() => {
            drawerCRUDStore.changeView(EDrawerView.RP_BONUS_CREATE)
          }}>
          Создать новый бонус
        </Button>
      )
    },
  })

  return <MaterialReactTable table={table} />
})

export default RpBonusesTable
